
<template>
  <v-autocomplete
                  v-model="value"
                  :items="statuses || $INVOICE_STATUSES"
                  item-title="label"
                  item-value="value"
                  :label="label"
                  :multiple="multiple"
                  hide-details
                  :density="small ? 'compact' : 'default'">
    <template v-slot:no-data>
      <div class="px-4">Digite sua busca</div>
    </template></v-autocomplete>
</template>
<script>
export default {
  components: {},
  props: {
    user: Object,
    label: String,
    modelValue: Array | Number,
    statuses: Array,
    multiple: Boolean,
    small: Boolean,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      requestingApi: false,
    };
  },
  created() { },
  mounted() { },
  activated() { },
  methods: {
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
  },
};
</script>
